import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import { Link } from "react-router-dom";
import Repo from "../../Utility/Repo";
import { useEffect, useState, useContext } from "react";
import Loader from "../../Components/Loader";
import { TokenContext } from "../../Components/TokenContext";
import  ValidISEE  from "../../Components/ValidISEE";
import  ValidUser  from "../../Components/ValidUser";
import LabelsLoader  from "../../Utility/labelsLoader";

function HomeUser(props) {
  const apiToken = useContext(TokenContext);
  const [loading, setLoading] = useState(true);
  const [services, setServices] = useState({});
  const [announcementsBacheca, setAnnouncementsBacheca] = useState();

  const labels = LabelsLoader();

  useEffect(() => {
    // 👇️ set isMounted to true
    let isMounted = true;
    async function fetchData() {
      const result = await Promise.resolve(["Unmounted Component"]);

      // 👇️ only update state if component is mounted
      if (isMounted) {
        setLoading(false);

        Repo.getAnnouncementsBacheca(apiToken)
          .then((response) => {
            setAnnouncementsBacheca(response.data);
            setLoading(true);
          })
          .catch((error) => {
            console.log(error);
          });

        Repo.getUserServices(apiToken)
          .then((response) => {
            setServices(response.data);
            setLoading(true);
          })
          .catch((error) => {
            console.log(error);
            setLoading(true);
          });
      }
    }

    fetchData();

    return () => {
      // 👇️ when component unmounts, set isMounted to false
      isMounted = false;
    };
  }, []);

  return (
    <>
      {/* {!props.userDataStatus && (
        <div className="alert alert-danger " role="alert">
          <h4 className="alert-heading">Attenzione!</h4>
          <div className="row">
            <div className="col-lg-10">
              <p>
                Per poterti iscrivere ai corsi devi completare i dati utente.
              </p>
            </div>
            <div className="col-lg-2 text-right">
              <Link to="/profilo">
                <button
                  type="button"
                  className="btn btn-outline-primary btn-sm"
                >
                  <span>Completa Dati</span>
                </button>
              </Link>
            </div>
          </div>
        </div>
      )} */}
    <ValidISEE />
    <ValidUser />

      {announcementsBacheca && announcementsBacheca.length > 0 && (
        <div className="row mt-4 mb-4">
          <div className="col-lg-12">
            <h3 className="pl-2 mb-3">Bacheca</h3>
            <p className="pl-2">{labels.bandi_aperti}</p>
            <div className="row">
              {announcementsBacheca &&
                announcementsBacheca.length > 0 &&
                announcementsBacheca.slice(0, 3).map((x, index) => (
                  <div key={x.id} className="col-12 col-lg-4">
                    <Link
                      to={"/sessione_servizi/visualizza_servizio?id=" + x.id}
                      className="text-decoration-none"
                    >
                      <div className="card-wrapper card-space cardCustom">
                        <div className="card card-bg no-after roundedCustomBandi p-2">
                          <div className="card-body">
                            <h5
                              style={{ fontSize: "23px" }}
                              className="card-title"
                            >
                              {x && x.name}
                            </h5>

                            <p
                              style={{ fontSize: "20px" }}
                              className="card-text mb-0"
                            >
                              Data inserimento:{" "}
                              <strong>{x && x.dataInsert}</strong>
                            </p>

                            <div className="row">
                              <div className="col-12 mt-4 text-right">
                                <button
                                  type="button"
                                  className="btn btn-outline-primary btn-sm"
                                >
                                  <span>Dettaglio</span>
                                  <span>
                                    <svg className="icon icon-primary icon-sm">
                                      <use
                                        href={`${iconSprite}#it-arrow-right`}
                                      />
                                    </svg>
                                  </span>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Link>
                  </div>
                ))}
            </div>
          </div>
        </div>
      )}
      <h1>Servizi</h1>
        <div className="clearfix col-lg-8 py-lg-2">
          <p> {labels.elenco_servizi}</p>
          </div>
      <div className="row">

        <div className="col-lg-8">
       

         

          <div className="row">
            {services &&
              services.length > 0 &&
              services.map((x, index) => (
                <div key={x.id} className="col-12 col-lg-12">
                  <Link
                    to={"/sessione_servizi?id=" + x.id}
                    className="text-decoration-none"
                  >
                    <div className="card-wrapper card-space cardCustom">
                      <div className="card card-bg no-after roundedCustom p-2 ">
                        <div className="card-body">
                          <h5
                            style={{ fontSize: "23px" }}
                            className="card-title"
                          >
                            {x.name}
                          </h5>
                          <div className="row">
                            <div className="col-12">
                              <p
                                style={{ fontSize: "20px" }}
                                className="card-text"
                              >
                                {x.description}
                              </p>
                            </div>
                            <div className="col-12 mt-4 text-right">
                              <button
                                type="button"
                                className="btn btn-outline-primary btn-sm"
                              >
                                <span> Richiedi Servizio</span>
                                <span>
                                  <svg className="icon icon-primary icon-sm">
                                    <use
                                      href={`${iconSprite}#it-arrow-right`}
                                    />
                                  </svg>
                                </span>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
              ))}
          </div>
        </div>
        <div className="col-lg-4">
        
          <div className="col-12 col-lg-12 mb-3">
            <Link to="/iscrizioni" className="text-decoration-none">
              <div className="card-wrapper card-space cardCustom">
                <div className="card card-bg no-after roundedCustom ">
                  <div className="card-body">
                    <div className="top-icon mb-2">
                      <svg className="icon icon-danger">
                        <use href={`${iconSprite}#it-file`} />
                      </svg>
                    </div>
                    <h5 className="card-title mb-1">Iscrizioni</h5>
                    <p className="card-text">
                      Accedendo a questa sezione potrai visualizzare i servizi a
                      cui sei iscritto, a cui hai effettuato richiesta di
                      iscrizione e i servizi dove non hai avuto accesso
                    </p>
                  </div>
                </div>
              </div>
            </Link>
          </div>
          <div className="col-12 col-lg-12 mb-3">
            <Link to="/caricamento_ISEE" className="text-decoration-none">
              <div className="card-wrapper card-space cardCustom">
                <div className="card card-bg no-after roundedCustom p-2">
                  <div className="card-body">
                    <div className="top-icon mb-2">
                      <svg className="icon icon-danger">
                        <use href={`${iconSprite}#it-plus-circle`} />
                      </svg>
                    </div>
                    <h5 className="card-title mb-1">Carica nuovo ISEE</h5>
                    <p className="card-text">
                      Accedendo a questa sezione potrai procedere con il
                      caricamento di un nuovo ISEE
                    </p>
                  </div>
                </div>
              </div>
            </Link>
          </div>
          <div className="col-12 col-lg-12 mb-3">
            <Link to="/profilo?scroll=true" className="text-decoration-none">
              <div className="card-wrapper card-space cardCustom">
                <div className="card card-bg no-after roundedCustom p-2">
                  <div className="card-body">
                    <div className="top-icon mb-2">
                      <svg className="icon icon-danger">
                        <use href={`${iconSprite}#it-files`} />
                      </svg>
                    </div>
                    <h5 className="card-title mb-1">ISEE Caricati</h5>
                    <p className="card-text">
                      Accedendo a questa sezione potrai visualizzare gli ISEE
                      caricati in precedenza
                    </p>
                  </div>
                </div>
              </div>
            </Link>
          </div>
          <div className="col-12 col-lg-12 mb-3">
            <Link
              to="/doc/Manuale.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="text-decoration-none"
            >
              <div className="card-wrapper card-space cardCustom">
                <div className="card card-bg no-after roundedCustom p-2">
                  <div className="card-body">
                    <div className="top-icon mb-2">
                      <svg className="icon icon-danger">
                        <use href={`${iconSprite}#it-search`} />
                      </svg>
                    </div>
                    <h5 className="card-title mb-1">Visualizza manuale</h5>
                    <p className="card-text">
                      Cliccando questa sezione verrà mostrato il manuale utente
                    </p>
                  </div>
                </div>
              </div>
            </Link>
          </div>
        </div>
      </div>

      {!loading && <Loader></Loader>}
    </>
  );
}

export default HomeUser;
